module.exports = __webpack_public_path__ + "static/textinput-label-do-76f31d336a869d63e64fc026be00b863.png";